module.exports = __webpack_public_path__ + "static/media/contctus.b579a8ff.png";